import { FETCH_GET, FETCH_POST } from "../../config";

export const FETCH_CATEGORY_NAVIGATIONS_PENDING = "FETCH_CATEGORY_NAVIGATIONS_PENDING";
export const FETCH_CATEGORY_NAVIGATIONS_FULFILLED = "FETCH_CATEGORY_NAVIGATIONS_FULFILLED";
export const FETCH_CATEGORY_NAVIGATIONS_REJECTED = "FETCH_CATEGORY_NAVIGATIONS_REJECTED";

export const FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_PENDING = "FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_PENDING";
export const FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_FULFILLED = "FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_FULFILLED";
export const FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_REJECTED = "FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_REJECTED";

export const fetchCategoryNavigations = () => {
  const query = `query={getActiveCategoryNavigations{id,title,categories{id,title,slug},icon,iconImage,customLink,order,active,style{bgColor,textColor,hoverColor}}}`;
  
  return async (dispatch) => {
    dispatch({ type: FETCH_CATEGORY_NAVIGATIONS_PENDING });
    
    try {
      const result = await FETCH_GET(query);
      
      if (result.data.errors) {
        dispatch({
          type: FETCH_CATEGORY_NAVIGATIONS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FETCH_CATEGORY_NAVIGATIONS_FULFILLED,
          payload: result.data.data.getActiveCategoryNavigations,
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CATEGORY_NAVIGATIONS_REJECTED,
        payload: [{ message: error.toString() }],
      });
    }
  };
};

export const fetchCategoryNavigationWithProducts = (id) => {
  const query = `query($id:ID!){getCategoryNavigationWithProducts(id:$id){id,title,categories{id,title,slug},products{id,name,slug,price,sale_price,image,stock,featured,active},icon,iconImage,customLink,order,active,style{bgColor,textColor,hoverColor}}}`;
  const variables = JSON.stringify({ id: id });

  return async (dispatch) => {
    dispatch({ type: FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_PENDING });

    try {
      const result = await FETCH_POST({ query: query, variables: variables });

      if (result.data.errors) {
        // GraphQL hataları - production'da sessiz
        if (process.env.NODE_ENV === 'development') {
          console.error('GraphQL Errors:', result.data.errors);
        }
      }

      if (result.data.data && result.data.data.getCategoryNavigationWithProducts) {
        const navigationData = result.data.data.getCategoryNavigationWithProducts;
        dispatch({
          type: FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_FULFILLED,
          payload: navigationData,
        });
      } else {
        dispatch({
          type: FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_REJECTED,
          payload: result.data.errors || [{ message: 'No data received' }],
        });
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Fetch Error:', error);
      }
      dispatch({
        type: FETCH_CATEGORY_NAVIGATION_WITH_PRODUCTS_REJECTED,
        payload: [{ message: error.toString() }],
      });
    }
  };
};


// WEBPACK FOOTER //
// ./src/store/actions/categoryNavigation.js